import { useEffect } from 'react';
import { useGame } from './board/score-context';

export function KeyWatcher() {
  const { isDropped, setIsDropped, balls } = useGame();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.code === 'Space' || event.code === 'Enter') {
        startDrop();
      }
    };
    const handleTouchStart = () => {
      startDrop();
    };
    const handleClick = () => {
      startDrop();
    };

    function startDrop() {
      if (!isDropped && balls > 0) {
        setIsDropped(true);
      }
    }

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('touchstart', handleTouchStart);
    window.addEventListener('click', handleClick);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('click', handleClick);
    };
  }, [isDropped, setIsDropped]);

  return null;
}
